(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["component-pdp-actions"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const checkbox = document.getElementById('wrings-crafting-consent');
    if (!checkbox) return;

    const form = checkbox.closest('form');
    if (!form) return;

    const addToCartBtn = form.querySelector('[type="submit"], .product-form__submit, button[name="add"]');
    if (!addToCartBtn) return;

    const messageWrapper = document.getElementById('wrings-crafting-message');
    const craftingMessage = messageWrapper?.dataset?.craftingMessage || '';

    addToCartBtn.addEventListener('click', function (e) {
      if (!checkbox.checked) {
        e.preventDefault();
        e.stopImmediatePropagation();

        if (!document.getElementById('crafting-consent-error')) {
          const error = document.createElement('div');
          error.id = 'crafting-consent-error';
          error.style.color = 'red';
          error.style.marginTop = '8px';
          error.textContent = 'Please agree to the crafting time consent before adding to cart.';
          const messageWrapper = document.getElementById('wrings-crafting-message');
          if (messageWrapper) messageWrapper.appendChild(error);
        }

        return false;
      }

      // Checkbox is checked, remove any existing error
      const existingError = document.getElementById('crafting-consent-error');
      if (existingError) existingError.remove();

      // Add hidden input if not already added
      if (!form.querySelector('[name="properties[Crafting Message]"]')) {
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'properties[Crafting Message]';
        hiddenInput.value = craftingMessage;
        form.appendChild(hiddenInput);
      }
    });

    checkbox.addEventListener('change', function () {
      if (this.checked) {
        const existingError = document.getElementById('crafting-consent-error');
        if (existingError) existingError.remove();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
